<script>
    export default {
        name: 'CheckOutlineIcon',
        props: {
            width: {
                type: [Number, String],
                required: false,
                default: 24,
            },
            height: {
                type: [Number, String],
                required: false,
                default: 24,
            },
        },
    };
</script>

<template>
    <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" class="fill-current">
        <path fill="none" d="M0 0h24v24H0V0z" />
        <path
            d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm3.88-11.71L10 14.17l-1.88-1.88a.996.996 0 10-1.41 1.41l2.59 2.59c.39.39 1.02.39 1.41 0L17.3 9.7a.996.996 0 000-1.41c-.39-.39-1.03-.39-1.42 0z" />
    </svg>
</template>
